import { useCallback } from "react";
const useIDPStateStore = () => {
  return {
    get: useCallback(() => {
      const item = sessionStorage.getItem("idp");
      if (!item) {
        return null;
      }
      return JSON.parse(item);
    }, []),
    set: useCallback((state) => {
      sessionStorage.setItem("idp", JSON.stringify(state));
    }, [])
  };
};
export {
  useIDPStateStore
};
//# sourceMappingURL=useIDPStateStore.js.map
